    import { CiHardDrive, CiMonitor, CiDesktop, CiUsb } from "react-icons/ci";
    import { PiPrinter, PiLaptop, PiDesktopTower } from "react-icons/pi";
    import { CgScreen, CgUsb } from "react-icons/cg";
    import { GoCpu } from "react-icons/go";
    import { BsMouse2, BsSdCard, BsKeyboard, BsWebcam } from "react-icons/bs";
    import { AiOutlineTablet, AiOutlineHome } from "react-icons/ai";
    import { GrGamepad } from "react-icons/gr";
    import { MdOutlineStarBorder, MdOutlineScanner, MdOutlineSurroundSound, MdOutlineLocalOffer, MdOutlineHeadsetMic  } from "react-icons/md";
    import { TiCloudStorageOutline } from "react-icons/ti";
    import { RiMacbookLine } from "react-icons/ri";
    import { LuPcCase, LuHeadphones } from "react-icons/lu";
    import { GiProcessor } from "react-icons/gi";
    import { LiaMicrophoneSolid, LiaHeadsetSolid, LiaVrCardboardSolid } from "react-icons/lia";
    import { IoPhonePortraitOutline } from "react-icons/io5";
    import { MdOutlinePhoneAndroid, MdOutlinePhonelink } from "react-icons/md";


    export const MapIcon = {
        // 33 icons
        CiHardDrive,
        PiPrinter,
        PiLaptop,
        CgScreen,
        GoCpu,
        BsMouse2,
        AiOutlineTablet,
        GrGamepad,
        MdOutlineStarBorder,
        AiOutlineHome,
        TiCloudStorageOutline,
        BsSdCard,
        MdOutlineScanner,
        RiMacbookLine,
        CiMonitor,
        MdOutlineSurroundSound,
        LuPcCase,
        LuHeadphones,
        BsKeyboard,
        LiaHeadsetSolid,
        GiProcessor,
        BsWebcam,
        LiaMicrophoneSolid,
        CiDesktop,
        PiDesktopTower,
        LiaVrCardboardSolid,
        MdOutlineLocalOffer,
        MdOutlineHeadsetMic ,
        IoPhonePortraitOutline,
        MdOutlinePhoneAndroid,
        MdOutlinePhonelink,
        CiUsb,
        CgUsb
    };